// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Othu","inner":"Footer_inner__2012g","nextIcon":"Footer_nextIcon__wPoTd","innerLeft":"Footer_innerLeft__1b7Fi"};